import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'fieldValidationMsg',
  standalone: true
})
export class FieldValidationMsgPipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);

  transform(value: string): string {
    const valueTranslation = this.translateService.instant(value) as string;

    return this.translateService.instant('global.isInvalid', {
      value: valueTranslation
    }) as string;
  }
}
